import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'system';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'system',
      setTheme: (theme) => {
        set({ theme });
        applyTheme(theme);
      },
    }),
    { name: 'mayksel-theme' },
  ),
);

export function applyTheme(theme: Theme) {
  document.documentElement.setAttribute('data-theme', theme);
}

/** Call once on app boot to restore the saved theme. */
export function initTheme() {
  const stored = localStorage.getItem('mayksel-theme');
  let theme: Theme = 'system';
  try {
    const parsed = JSON.parse(stored ?? '{}') as { state?: { theme?: Theme } };
    theme = parsed.state?.theme ?? 'system';
  } catch {
    // ignore
  }
  applyTheme(theme);
}
